// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HAv5","colMin":"styles_colMin__9cf-S"};